const removeFormatCPF = (cpf) => {
  cpf = cpf.replaceAll('.', '');
  cpf = cpf.replaceAll('-', '');
  return cpf;
};

export default removeFormatCPF;
